import type { CmsDatabase, CmsRepository } from './types';

/**
 * 废弃的 Mock 仓库轻量空实现。
 * 所有真实业务数据已全面切换至 BFF 接口，禁止向 localStorage 写入假数据。
 */
export const createCmsRepository = (_tenantId = 'default'): CmsRepository => ({
  getSnapshot: async () => undefined as unknown as CmsDatabase,
  reset: async () => undefined as unknown as CmsDatabase,
  saveContent: async (content) => content,
  setContentStatus: async () => ({}) as any,
  createContent: async () => ({}) as any,
  createSite: async () => ({}) as any,
  saveBrief: async (brief) => brief,
  savePage: async (page) => page,
  saveMapping: async (mapping) => mapping,
  updateSeoIssue: async () => ({}) as any,
  savePublishTask: async (task) => task,
  createForm: async () => ({}) as any,
  updateLead: async () => ({}) as any,
  createApiKey: async () => ({}) as any,
  updateApiKey: async () => ({}) as any,
  saveWebhook: async (webhook) => webhook,
  saveKnowledgeEntity: async (entity) => entity,
  saveFact: async (fact) => fact,
  saveWorkspaceRecord: async () => ({}) as any,
  updateWorkspaceRecord: async () => ({}) as any,
  deleteWorkspaceRecord: async () => {},
});
